import React, { FC, useMemo } from 'react';
import clsx from 'clsx';

export const ActiveRibbon: FC<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  jsonContent: any;
  recentlyViewedFlag: boolean;
  isFullyRenovated: boolean;
  isRecentlyRenovated: boolean;
  hasRenovatedRooms: boolean;
  newProperty: boolean;
  newLobby: boolean;
}> = ({
  jsonContent,
  recentlyViewedFlag,
  isFullyRenovated,
  isRecentlyRenovated,
  hasRenovatedRooms,
  newProperty,
  newLobby,
}) => {
  const ribbonFlag = useMemo(() => {
    if (recentlyViewedFlag) {
      return 'recently-viewed-ribbon';
    } else if (isFullyRenovated) {
      return 'fully-renovated-ribbon';
    } else if (isRecentlyRenovated) {
      return 'recently-renovated-ribbon';
    } else if (hasRenovatedRooms) {
      return 'renovated-rooms-ribbon';
    } else if (newProperty) {
      return 'new-hotel-ribbon ribbon';
    } else if (newLobby) {
      return 'renovated-lobby-ribbon';
    } else {
      return null;
    }
  }, [recentlyViewedFlag, isFullyRenovated, isRecentlyRenovated, hasRenovatedRooms, newProperty, newLobby]);

  const ribbonLabel = useMemo(() => {
    if (recentlyViewedFlag) {
      return jsonContent?.recentlyViewedHeading;
    } else if (isFullyRenovated) {
      return jsonContent.fullyRenovatedLabel;
    } else if (isRecentlyRenovated) {
      return jsonContent.recentlyRenovatedLabel;
    } else if (hasRenovatedRooms) {
      return jsonContent.renovatedRoomsLabel;
    } else if (newProperty) {
      return jsonContent.newTagLabel;
    } else if (newLobby) {
      return jsonContent.renovatedLobbyLabel;
    } else return null;
  }, [
    recentlyViewedFlag,
    isFullyRenovated,
    isRecentlyRenovated,
    hasRenovatedRooms,
    newProperty,
    newLobby,
    jsonContent,
  ]);

  return (
    ribbonFlag &&
    ribbonLabel && (
      <div className={clsx('ribbon', ribbonFlag)} tabIndex={0} role="status" aria-live="polite">
        {' '}
        <div className="t-label-alt-xs ribbon-text">{ribbonLabel}</div>{' '}
      </div>
    )
  );
};
